import React, {useState} from 'react';
import {Form, Input, Row, Col} from 'antd';
import {EyeInvisibleOutlined, EyeOutlined, LockOutlined} from '@ant-design/icons';
import Button, {BUTTON_TYPE} from "@common/Button";

const PasswordChangeForm = props => {
    const {data, checkFormStatus, handleSubmitForm} = props;
    const [submittable, setSubmittable] = useState(false);
    const [disabled, setDisabled] = useState(false);
    const [form] = Form.useForm();

    const handleSubmitFormWrapper = async (values) => {
        setDisabled(true);
        const formData = { ...values };
        delete formData.confirmPassword;

        try {
            const response = await handleSubmitForm(form, formData, {}, "/web/ui/accountSettings/updateUserPassword");
            if (!response.data.errors) {
                displayToastMessage("Update successful", "", "success", undefined, 4000);
            }
        } catch (e) {
            setDisabled(false);
        } finally {
            setDisabled(false);
        }
    };

    return (
        <div>
            <h3>Manage password</h3>
            <Form
                name="password"
                form={form}
                layout="vertical"
                onFieldsChange={() => setSubmittable(checkFormStatus(form))}
                onFinish={handleSubmitFormWrapper}
                initialValues={{
                    oldPassword: '',
                    newPassword: '',
                    confirmPassword: ''
                }}
            >
                <Form.Item
                    label="Previous Password"
                    name="oldPassword"
                    rules={data?.validation.oldPassword}
                    validateTrigger="onBlur"
                >
                    <PasswordInput
                        aria-required="true"
                        buttonAriaLabel="Previous Password"
                        autoComplete="current-password"
                    />
                </Form.Item>
                <Form.Item
                    label="New Password"
                    name="newPassword"
                    rules={data?.validation.newPassword}
                    validateTrigger="onBlur"
                >
                    <PasswordInput
                        aria-required="true"
                        buttonAriaLabel="New Password"
                        autoComplete="new-password"
                    />
                </Form.Item>
                <Form.Item
                    label="Confirm New Password"
                    name="confirmPassword"
                    rules={[
                        { required: true, message: "Confirm new password is required" },
                        ({ getFieldValue }) => ({
                            validator(_, value) {
                                if (!value || getFieldValue("newPassword") === value) {
                                    return Promise.resolve();
                                }
                                return Promise.reject("New password and confirm new password do not match");
                            },
                        }),
                    ]}
                    validateTrigger="onBlur"
                >
                    <PasswordInput
                        aria-required="true"
                        buttonAriaLabel="Confirm New Password"
                        autoComplete="new-password"
                    />
                </Form.Item>
                <Row>
                    <Col>
                        <Button type="primary" htmlType="submit" disabled={disabled ? disabled : !submittable}>
                            Update password
                        </Button>
                    </Col>
                </Row>
            </Form>
        </div>
    );
};

const PasswordInput = props => {
    const {buttonAriaLabel = "password", ...other} = props;
    const [passwordVisible, setPasswordVisible] = useState(false);

    return (
        <div className="flexInline" style={{width: "100%", gap: "var(--spacing-unit)"}}>
            <Input
                className="flexMax"
                type={passwordVisible ? "text" : "password"}
                prefix={<LockOutlined role="none" aria-hidden="true" />}
                suffix={passwordVisible ? <EyeInvisibleOutlined role="none" aria-hidden="true" /> : <EyeOutlined role="none" aria-hidden="true" />}
                {...other}
            />
            <Button
                className="flex"
                htmlType="button"
                type={BUTTON_TYPE.OUTLINE}
                style={{ width: 80 }}
                aria-label={passwordVisible ? ("Hide " + buttonAriaLabel) : ("Show " + buttonAriaLabel)}
                onClick={() => setPasswordVisible((prevState) => !prevState)}
            >
                {passwordVisible ? "Hide" : "Show"}
            </Button>
        </div>
    )
}

export default PasswordChangeForm;